var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-tab-list"},[_c('h2',{staticClass:"header-tab-list__title"},[_vm._t("title")],2),_c('div',{staticClass:"header-tab-list__nav"},[_vm._t("nav")],2),(_vm.hasExtraSlot)?_c('div',{staticClass:"header-tab-list__extra"},[_vm._t("extra")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }